
<template>
  <div class="container">
    <template v-if="!showGuide">
      <Header/>
      <div class="content-wrap">
        <HubInfo
            show-edit
            :device-name="hubName"
            :device-id="macAddress"
            device-type="0"
            @onUpdateDeviceName="onUpdateDeviceName"/>

        <div class="card">
          <PowerCurve
              ref="powerCurve"
              :powers="powers"
              :r="r"
              :max-voltage="maxVoltage"
              :min-voltage="minVoltage"
              @change="onVoltagesChange"/>
        </div>

        <div class="card">
          <DeviceParams :disabled="!isSupportLevel" is-bluetooth :level="btLevel" :r="resistance" @change="onDeviceLevelChange"/>
        </div>

        <div class="flex flex-row items-center text-center gap-3 mt-10">
          <div @click="onAllHistoryClick" class="flex-1 bg-white curve-list-btn">All History</div>
          <div @click="onMyCurveListClick" class="flex-1 text-white curve-list-btn"
              style="background: #121212">My Curve List
          </div>
        </div>
      </div>
      <BottomOperate :func-type="funcType"
          @onFuncTypeChange="onFuncTypeChange"
          @onWrite="onWrite" @onRead="onRead"/>

    </template>

    <!-- Device Popup -->
    <van-popup
        class="settings-popup"
        position="bottom"
        round
        v-model="showSettingsPopup"
    >
      <CurrentSetting
          v-if="showSettingsPopup"
          :r-value="coilResistorValue"
          :max-value="parseFloat(this.maxPowerValue)"
          :showSettingsPopup="showSettingsPopup"
          @onApplyToHome="onApplyToHome"
          v-on:close="onCloseDeviceSetting"
      />
    </van-popup>


    <!--    <NFCGuide :func-type="1" v-model="showGuide" @onRead="onRead"/>-->


    <template v-if="showGuide">
      <div class="nfc-mask">
        <NFCGuideMask :func-type="1" v-model="showGuide" @onRead="onRead"
            @onFuncTypeChange="onFuncTypeChange"/>
      </div>

    </template>

    <DialogTips
        v-model="showBluetoothTips"
        title="Unconnected"
        message="Please connect your product to the device!"
        left-text="Exit"
        right-text="Enter"
        @onLeftClick="onBluetoothTipExitClick"
        @onRightClick="onBluetoothTipEnterClick"/>
  </div>
</template>

<script>
import DeviceName from "@/components/home/DeviceName";
import Header from "@/components/home/Header";
import Specification from "@/components/home/Specification";
import BottomOperate from "@/components/home/BottomOperate";
import DeviceParams from "@/components/home/DeviceParams";
import PowerCurve from "@/components/home/PowerCurve.vue";
import { calcPower, calcVoltageFloorInt, getDeviceMacAddress, toFloat } from "@/util/utils";
import NFCPopup from "@/components/nfc/NFCPopup.vue";
import { WriterSetting } from "@/bluetooth/BluetoothData";
import { mapGetters, mapState } from "vuex";
import PopupDeviceCurve from "@/components/PopupDeviceCurve.vue";
import log from "@/util/log";
import bluetoothRepository from "@/bluetooth/BluetoothRepository";
import CurrentSetting from "@/components/CurrentSetting.vue";
import NFCGuide from "@/components/home/NFCGuide.vue";
import DialogTips from "@/components/DialogTips.vue";
import HubInfo from "@/components/home/HubInfo.vue";
import NFCGuideMask from "@/components/home/NFCGuideMask.vue";

export default {
  name: "BtHome",
  components: {
    NFCGuideMask,
    DialogTips,
    NFCGuide,
    CurrentSetting,
    PopupDeviceCurve,
    NFCPopup,
    PowerCurve,
    DeviceParams,
    BottomOperate,
    Specification,
    Header,
    DeviceName,
    HubInfo
  },
  props: {},
  data() {
    return {
      powers: [[1, 2], [2, 3], [3, 4], [4, 1], [5, 3], [6, 3.3], [7, 1], [8, 3]],
      maxVoltage: 3500,
      minVoltage: 300,
      btLevel: 0,
      maxPowerValue: 10,

      typeOfDevice: 0,

      funcType: 1, //1是蓝牙 2是nfc

      //蓝牙连接
      connectTimeoutId: -1,
      cancelSearchTimeoutId: -1,
      currentDeviceIndex: 0,

      //
      showSettingsPopup: false,

      hubName: "OMNI HUB",

      tagInfoLoading: false,
      ingredientsText: "",
      tagDetail: null,
      ingredientSeries: [],

      showBluetoothPopup: false,
      showDisconnectPopup: false,
      showGuide: false,

      r: 1.2,

      showBluetoothTips: false
    };
  },
  methods: {
    ...mapGetters("bluetooth", ["getInsertDeviceName"]),
    getDeviceMacAddress,
    onUpdateDeviceName(content) {
      this.hubName = content.trim();
    },
    onDeviceLevelChange(val) {
      this.btLevel = val
    },
    onBluetoothTipExitClick() {
      this.showBluetoothTips = false;
    },
    onBluetoothTipEnterClick() {
      //TODO: 跳转到蓝牙设备连接
      this.$router.push("/hub-devices");
    },
    onAllHistoryClick() {
      this.$router.push("History");
    },
    onMyCurveListClick() {
      this.$router.push("Favorite");
    },
    onVoltagesChange(powers) {
      this.powers = powers;
    },

    //蓝牙弹窗
    touchstart(e) {
    },
    touchmove(e) {
    },

    onClickSwitchLeft() {
      if (this.currentDeviceIndex > 0) {
        this.currentDeviceIndex -= 1;
        this.$refs.deviceSwipe.swipeTo(this.currentDeviceIndex);
      }
      // log(this.$refs.deviceList);
      // const imgWidth = document.getElementsByClassName("hub-img")[0]
      //   .clientWidth;
    },
    onClickSwitchRight() {
      if (this.currentDeviceIndex + 1 < this.deviceList.length) {
        this.currentDeviceIndex += 1;
        this.$refs.deviceSwipe.swipeTo(this.currentDeviceIndex);
      }
      // const imgWidth = document.getElementsByClassName("hub-img")[0]
      //   .clientWidth;
      // this.$refs.deviceList.scrollLeft += imgWidth;
      // log(imgWidth);
      // log(this.$refs.deviceList.scrollLeft);
    },

    onCloseDeviceSetting() {
      this.showSettingsPopup = false;
    },

    onApplyToHome(writerSetting) {
      this.showSettingsPopup = false;
    },

    onClickConnectDevice() {
      if (this.isConnected) {
        return;
      }
      const device = this.deviceList[this.currentDeviceIndex];
      if (device) {
        this.$toast({
          type: "loading",
          message: "Connecting...",
          duration: 10000,
          forbidClick: true //禁止背景点击
        });
        //发送请求查询蓝牙设备名称
        this.hubName = device.serverName || device.name;
        bluetoothRepository.connectDevice(device, true);
        this.connectTimeoutId = setTimeout(() => {
          if (!this.isConnected) {
            this.$toast({
              type: "fail",
              message: "Connection failed",
              duration: 2000,
              forbidClick: true
            });
          }
        }, 10000);
      }
    },

    onClickDisconnectCancel() {
      this.showDisconnectPopup = false;
    },
    onClickDisconnectSure() {
      bluetoothRepository.disconnect();
      this.showDisconnectPopup = false;
    },

    async loadDeviceSetting(showLoading = true) {
      if (this.isConnected) {
        this.queryDeviceTimeoutId = setTimeout(() => {
          if (this.retryQueryTimes > 0) {
            this.retryQueryTimes -= 1;
            this.loadDeviceSetting(true);
          } else {
            this.$toast.fail("Read device coil resistor timeout");
            this.retryQueryTimes = 3;
          }
        }, 2000);

        try {
          if (showLoading) {
            this.$toast({
              type: "loading",
              message: "Reading coil resistor..."
            });
          }
          await bluetoothRepository.queryWriter();


          log(`清除定时器`);
          clearTimeout(this.queryDeviceTimeoutId);
          this.queryDeviceTimeoutId = -1;
          if (showLoading) {
            this.$toast.clear();
          }
          this.retryQueryTimes = 3;
        } catch (e) {
          clearTimeout(this.queryDeviceTimeoutId);
          this.queryDeviceTimeoutId = -1;
          // if (showLoading) {
          // setTimeout(() => {
            // this.$toast.fail(`${e} Current coil resistor is 1.2ohm`);
          // }, 1000);

          // }
        }
      } else {
        this.$toast({
          type: "fail",
          duration: "2000",
          position: "center",
          message: "No coil connected, the preset resistor is 1.2 ohm."
        });
      }
    },

    //底部按钮
    onClickCloseBluetoothPopup() {
      clearTimeout(this.cancelSearchTimeoutId);
      bluetoothRepository.cancelSearch();
      this.showBluetoothPopup = false;
    },

    onFuncTypeChange(e) {
      log(`func type = ${e}`);
      if (e === 1) {
        //bt 判断是否连接，没有连接进行连接
        this.showFunction = false;

        if (!this.isConnected) {
          this.$toast({
            type: "fail",
            duration: 2000,
            position: "center",
            message: "Not connected, Searching Hub"
          });
        }

        this.$router.push("/hub-devices");
        // if (this.isConnected) {
        //   this.showDisconnectPopup = true;
        //   bluetoothRepository.disconnect();
        // } else {
        //   bluetoothRepository.startPair();
        //   //如果浏览器有receiveScanDevice发送蓝牙设备列表则走web方式，没有走原生
        //   if (Object.prototype.hasOwnProperty.call(window, "receiveScanDevice")) {
        //     this.showBluetoothPopup = true;
        //   }
        // }
      } else {
        // nfc
        this.$router.replace("/enterprise");
      }
    },


    refreshVoltageCurve() {

    },

    getVoltages() {
      return this.powers.map((item) => {
        return calcVoltageFloorInt(item[1], this.r);
      });
    },
    async onRead() {
      if (!this.isConnected) {
        this.$toast({
          type: "fail",
          duration: 2000,
          position: "center",
          message: "Not connected, Searching Hub"
        });
        this.$router.push("/hub-devices");
        return;
      }
      this.showSettingsPopup = true;
    },
    async onWrite() {
      log("蓝牙写入");
      if (!this.isConnected) {
        this.$toast({
          type: "fail",
          duration: 2000,
          position: "center",
          message: "Not connected, Searching Hub"
        });
        return;
      }

      let r = toFloat(this.coilResistorValue, 1.2);
      if (r.toString() === "NaN") {
        r = 1.2;
      }
      const maxPower = toFloat(this.maxPowerValue, 10);

      const writerSetting = new WriterSetting();
      writerSetting.diyVoltage = this.getVoltages();
      log(
          `写入的档位：${this.btLevel} ，是否支持档位写入：${this.isSupportLevel}`
      );
      try {
        await bluetoothRepository.writeToWriter(
            writerSetting,
            this.isSupportLevel,
            this.btLevel
        );
        this.$toast({
          type: "success",
          message: "Upload success"
        });
      } catch (e) {
        this.$toast({
          type: "fail",
          duration: "1000",
          position: "center",
          message: "Send fail!"
        });
        return;
      }
    }
  },
  computed: {
    ...mapState("bluetooth", [
      "isConnected",
      "macAddress",
      "cartridgeFlag",
      "deviceVersion",
      "deviceList",
      "writerSetting",
      "connectState",
      "deviceId",
      "insertDeviceName",
      "level"
    ]),
    isD019() {
      if (this.isConnected) {
        if (this.deviceId) {
          const insertDeviceName = this.insertDeviceName.name;
          if (
              insertDeviceName === "PORTO" ||
              insertDeviceName === "D022" ||
              insertDeviceName === "D023"
          ) {
            return true;
          }
        }
      }
      return false;
    },
    resistance() {
      if (this.isConnected) {
        if (this.deviceId) {
          const r = this.deviceId.atomizedR;
          if (this.getInsertDeviceName().name == "NORD") {
            return 1.2;
          }
          return `${parseFloat((r / 10).toFixed(1))}`;
        }
        //没有插入设备
        return 1.2;
      }
      return -1;
    },

    coilResistorValue() {
      if (this.deviceId) {
        const r = this.deviceId.atomizedR;
        if (this.getInsertDeviceName() == "NORD") {
          return 1.2;
        }
        return parseFloat((r / 10).toFixed(1));
      }
      return 1.2;
    },


    //是否显示成分
    showSpecification() {
      if (this.typeOfDevice > 0 && this.funcType === 2) {
        return true;
      }
      return false;
    },
    //从linechart中取出y值
    currentPower() {
      return this.powers.map(item => item[1]);
    },
    isSupportLevel() {
      if (this.isConnected) {
        if (this.deviceId) {
          const insertDeviceName = this.insertDeviceName.name;
          if (
              insertDeviceName === "510 Pen" ||
              insertDeviceName === "Lipstick" ||
              insertDeviceName === "PORTO" ||
              insertDeviceName === "D022" ||
              insertDeviceName === "D023"
          ) {
            return true;
          }
        }
      }
      return false;
    }
  },
  watch: {
    async isConnected(value) {
      if (value) {
        clearTimeout(this.connectTimeoutId);
        // this.$toast({
        //   type: "success",
        //   message: "Device Connected",
        //   duration: 1500,
        //   forbidClick: true
        // });

        this.$store.dispatch("bluetooth/setShowBtGuide", true);
        this.showGuide = false

        await this.loadDeviceSetting(false);

        this.cancelSearchTimeoutId = setTimeout(() => {
          this.showBluetoothPopup = false;
          bluetoothRepository.cancelSearch();
        }, 2000);

      } else {
        clearTimeout(this.cancelSearchTimeoutId);
      }
    },
    level(value) {
      this.btLevel = value;
    },
    coilResistorValue(newValue) {
      if (parseFloat(newValue).toString() === "NaN") {
        return;
      }
      log(`change = ${newValue}`);
      // this.onChangeRDropdown(newValue);
    },

    deviceList(value) {
      log(value);
    },
    deviceId(value) {
      if (value) {
        if (value.type === 5) {
          //电池修改颜色
          const level = ((value.productManufacture >> 4) & 0x0f) - 1;
          log(`当前电池杆等级:${level}`);
          if (level < 3) {
            this.curveColor = this.curveLevelColor[level];
            this.curveColorLinearGradient = this.curveLevelColorLinearGradient[
                level
                ];
            this.btLevel = level;
            this.refreshVoltageCurve();
            return;
          }
        }
      } //为空了
      if (this.isD019) {
        const level = this.level;
        log(`当前d019的档位:${level}`);
        if (level < 2) {
          this.currentDeviceLevelItem = Object.assign({}, this.deviceLevelList[level]);
          this.currentDeviceLevel = this.level;
          log(JSON.stringify(this.currentDeviceLevelItem));
        }
      }
      this.refreshVoltageCurve();
    },

    resistance(newVal) {
      this.r = newVal;
    }

  },
  async mounted() {
    this.maxVoltage = calcVoltageFloorInt(10, this.r);
    this.minVoltage = calcVoltageFloorInt(0.1, this.r);

    // this.showSettingsPopup = true
    this.showGuide = false // = await this.$store.dispatch("bluetooth/checkShowBtGuide");
  },
  activated() {

    // this.showBluetoothTips = !this.isConnected
    localStorage.setItem("last_path", "/bt-home");
    const writerSetting = this.$route.params.writerSetting;
    if (writerSetting) {
      this.$nextTick(() => {
        this.r = writerSetting.resistance;
        this.maxPowerValue = writerSetting.maxPower;
        writerSetting.diyVoltage.forEach((item, index) => {

          this.powers[index][1] = calcPower(Math.abs(item), writerSetting.resistance, writerSetting.maxPower);
        });
        log(`读取的电压为 ： ${writerSetting.diyVoltage}`);
        log(`读取的功率为 ： ${this.powers}`);

        this.$refs.powerCurve.refreshCurve(true);
      });
    }
  }
};
</script>

<style scoped lang="less">
.content-wrap {
  position: absolute;
  overflow-y: auto;
  width: 100%;
  height: calc(100vh - 44px - calc(70px + env(safe-area-inset-bottom)));
  margin-top: 44px;

  padding: 0 16px 16px 16px;

  & > * {
    margin-top: 10px;
  }

}


.curve-list-btn {
  height: 40px;
  line-height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;

}

.curve-list-btn {
  height: 40px;
  line-height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}


.bluetooth-popup {
  display: flex;
  flex-direction: column;

  .popup-header {
    margin: 24px 0 35px 0;
    padding: 0 25px;
    font-size: 21px;
    font-weight: bold;
    color: #6d6e71;
    display: flex;
    align-items: center;

    span {
      margin-left: auto;
      font-size: 21px;
      font-weight: bold;
      color: #bcbec0;
    }
  }

  .popup-content {
    margin: 0 25px 50px 25px;
    background: #ffffff;
    box-shadow: 0px 1px 10px 1px rgba(126, 133, 135, 0.6);
    border-radius: 10px;
    display: flex;
    flex-direction: column;

    .device-title {
      margin-top: 29px;
      margin-left: 34px;
      font-size: 24px;
      font-weight: bold;
      color: #6d6e71;
    }

    .device-mac {
      margin-top: 14px;
      margin-left: 34px;
      font-size: 18px;
      font-weight: normal;
      color: #939598;
    }

    .device-list {
      width: 100%;
      display: flex;
      align-items: center;
      margin: 0 15px;

      .device-left {
        width: 16px;
        height: 35px;
      }

      .device-hub-list {
        width: calc(100vw - 112px);
        overflow: hidden;
        display: flex;
        align-items: center;

        img {
          width: 100%;
        }
      }

      .device-right {
        width: 19px;
        height: 35px;
      }
    }

    .button-connect {
      width: calc(100% - 32px);
      margin: 0 16px;
      height: 45px;
      background: var(--curveColor);
      border-radius: 5px;
      font-size: 18px;
      font-weight: bold;
      color: #ffffff;
      margin-bottom: 29px;
    }

    .no-device {
      margin: 0 auto;
      margin-top: 124px;
    }

    .no-device-msg {
      margin-top: 10px;
      margin-bottom: 185px;
      font-size: 18px;
      font-weight: normal;
      color: #bcbec0;
      text-align: center;
    }
  }
}

.settings-popup {
  width: 100%;
  height:409px;

  .popup-header {
    font-size: 21px;
    font-weight: bold;
    color: #6d6e71;
    display: flex;

    align-items: center;
    padding: 20px 20px 48px 28px;

    img {
      margin-left: auto;
      width: 28px;
      height: 28px;
    }
  }

  .popup-content {
    display: flex;
    overflow-y: auto;
    flex-direction: column;
    padding: 0 20px 0 28px;

    .title {
      margin-bottom: 15px;
      font-size: 16px;
      font-weight: normal;
      color: #a7a9ac;
    }

    .info {
      font-size: 18px;
      font-weight: normal;
      color: #808285;
      display: flex;
      align-items: center;
      margin-bottom: 33px;

      img {
        margin-left: auto;
        margin-right: 3px;
        width: 19px;
        height: 19px;
      }
    }

    .device {
      margin-bottom: 34px;

      .device-name {
        font-size: 21px;
        font-weight: bold;
        color: #6d6e71;
      }

      .device-address {
        font-size: 18px;
        font-weight: normal;
        color: #939598;
      }
    }

    .preheat {
      margin-bottom: 45px;

      .preheat-title {
        font-size: 21px;
        font-weight: bold;
        color: #6d6e71;
      }

      .preheat-time {
        margin-top: 20px;
        font-size: 18px;
        font-weight: normal;
        color: #939598;
      }

      .preheat-voltage {
        margin-top: 17px;
        font-size: 18px;
        font-weight: normal;
        color: #939598;
      }
    }

    .voltage {
      margin-bottom: 33px;

      .voltage-title {
        font-size: 21px;
        font-weight: bold;
        color: #6d6e71;
      }

      .voltage-mode {
        margin-bottom: 24px;
        font-size: 18px;
        font-weight: normal;
        color: #939598;
      }
    }
  }

  .popup-button {
    margin: 62px 25px 27px 25px;
    height: 45px;
    line-height: 45px;
    background: var(--themeMainColor);
    border-radius: 8px;
    text-align: center;
    font-size: 21px;
    font-weight: bold;
    color: #ffffff;
  }
}


.save-popup {
  .save-header {
    font-size: 21px;
    font-weight: bold;
    color: #6d6e71;
    padding: 20px 0;
    text-align: center;
  }

  .save-content {
    padding: 15px 23px 20px 23px;
    font-size: 18px;
    color: #231f20;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .edit-content {
    padding: 15px 23px 20px 23px;
    font-size: 18px;
    color: #231f20;
    display: flex;
    flex-direction: column;

    .edit-content-msg {
      font-size: 18px;
      color: #231f20;
    }

    .input-rename {
      margin-top: 10px;
      height: 45px;
      border-radius: 8px;
      border: 1px solid #a7a9ac;
      background: #ffffff;
    }

    .memo-content-msg {
      margin-top: 10px;
      font-size: 18px;
      color: #231f20;
    }

    .input-memo {
      margin-top: 10px;
      height: 180px;
      border-radius: 8px;
      border: 1px solid #a7a9ac;
      background: #ffffff;
    }
  }

  .save-footer {
    display: flex;
    align-items: center;
    width: 100%;

    .save-footer-cancel {
      margin-right: 5px;
      margin-top: 30px;
      width: 100%;
      color: #939598;
      background: var(--cancelButtonColor);
    }

    .save-footer-sure {
      margin-left: 5px;
      color: #ffffff;
      background: #333333;
      margin-top: 30px;
      width: 100%;
    }
  }

  .nfc-mask {
    padding: 0px;
    z-index: 2000;
  }
}
</style>